import * as MobileAuthForm from './components/MobileAuthForm.css';
export default {
    MobileAuthForm
};
